import { render } from "./KAA.vue?vue&type=template&id=a23be450&scoped=true"
import script from "./KAA.vue?vue&type=script&lang=js"
export * from "./KAA.vue?vue&type=script&lang=js"

import "./KAA.vue?vue&type=style&index=0&id=a23be450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23be450"]])

export default __exports__